import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/AdminLayout";
import api from "../../lib/api";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function PaymentsPage() {
    const [students, setStudents] = useState([]);
    const [buses, setBuses] = useState([]);
    const [tab, setTab] = useState("due");

    const load = async () => {
        const [s, b] = await Promise.all([api.get("/students"), api.get("/buses")]);
        setStudents(s.data);
        setBuses(b.data);
    };
    useEffect(() => {
        load();
    }, []);

    const mark = async (s, status) => {
        await api.patch(`/students/${s.id}`, { payment_status: status });
        toast.success(`${s.name} marked ${status.toUpperCase()}`);
        load();
    };

    const due = students.filter((s) => s.payment_status === "due");
    const paid = students.filter((s) => s.payment_status === "paid");
    const list = tab === "due" ? due : paid;
    const busById = (id) => buses.find((b) => b.id === id);

    return (
        <AdminLayout>
            <div className="p-4 sm:p-8 lg:p-12 max-w-[1400px]">
                <div className="mb-10">
                    <p className="label-caps mb-2">Compliance</p>
                    <h1 className="font-display text-5xl text-[#111111]">Payment Report</h1>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <button
                        onClick={() => setTab("due")}
                        data-testid="tab-due"
                        className={`text-left p-6 border transition-all ${
                            tab === "due"
                                ? "bg-[#FF3B30] text-white border-[#FF3B30]"
                                : "bg-white text-[#111111] border-[#E5E5E5] hover:border-[#FF3B30]"
                        }`}
                    >
                        <AlertCircle size={24} className="mb-4" />
                        <div className="font-display text-5xl leading-none">{due.length}</div>
                        <div className="label-caps mt-2" style={{ color: tab === "due" ? "rgba(255,255,255,0.8)" : undefined }}>
                            Payment Due
                        </div>
                    </button>
                    <button
                        onClick={() => setTab("paid")}
                        data-testid="tab-paid"
                        className={`text-left p-6 border transition-all ${
                            tab === "paid"
                                ? "bg-[#34C759] text-white border-[#34C759]"
                                : "bg-white text-[#111111] border-[#E5E5E5] hover:border-[#34C759]"
                        }`}
                    >
                        <CheckCircle2 size={24} className="mb-4" />
                        <div className="font-display text-5xl leading-none">{paid.length}</div>
                        <div className="label-caps mt-2" style={{ color: tab === "paid" ? "rgba(255,255,255,0.8)" : undefined }}>
                            Paid
                        </div>
                    </button>
                </div>

                <div className="bg-white border border-[#E5E5E5]">
                    <div className="px-6 py-4 border-b-2 border-[#111111]">
                        <h2 className="font-display text-xl">
                            {tab === "due" ? "Students with Payment Due" : "Paid Students"}
                        </h2>
                    </div>
                    <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-[#F8F9FA] border-b-2 border-[#111111]">
                            <tr>
                                <th className="text-left font-bold py-3 px-4">Name</th>
                                <th className="text-left font-bold py-3 px-4">Roll</th>
                                <th className="text-left font-bold py-3 px-4">Department</th>
                                <th className="text-left font-bold py-3 px-4">Bus</th>
                                <th className="text-right font-bold py-3 px-4">Action</th>
                            </tr>
                        </thead>
                        <tbody data-testid="payments-table">
                            {list.map((s) => (
                                <tr key={s.id} className="border-b border-[#E5E5E5] hover:bg-[#F8F9FA]">
                                    <td className="py-3 px-4 font-medium">{s.name}</td>
                                    <td className="py-3 px-4 font-mono text-xs">{s.roll_number}</td>
                                    <td className="py-3 px-4 text-[#666666]">{s.department}</td>
                                    <td className="py-3 px-4 text-[#666666]">
                                        {busById(s.assigned_bus_id)?.bus_name || "—"}
                                    </td>
                                    <td className="py-3 px-4 text-right">
                                        {tab === "due" ? (
                                            <button
                                                onClick={() => mark(s, "paid")}
                                                data-testid={`mark-paid-${s.roll_number}`}
                                                className="bg-[#34C759] text-white font-bold px-4 py-2 text-xs uppercase tracking-wider hover:bg-[#2AB04A]"
                                            >
                                                Mark Paid
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => mark(s, "due")}
                                                data-testid={`mark-due-${s.roll_number}`}
                                                className="bg-white text-[#FF3B30] border border-[#FF3B30] font-bold px-4 py-2 text-xs uppercase tracking-wider hover:bg-[#FF3B30] hover:text-white"
                                            >
                                                Mark Due
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            {list.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="p-8 text-center text-[#666666]">
                                        No students in this category.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}
